import React from 'react';
import Img from "gatsby-image"
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby'

import IconFacebook from '../../images/svgs/facebook-icon.svg'
import IconInstagram from '../../images/svgs/instagram-icon.svg'
import IconLinkedin from '../../images/svgs/linkedin-icon.svg'
import IconTwitter from '../../images/svgs/twitter-icon.svg'

export default function Card( props ) {

	const { artist, trailYear, index } = props
	const { artistImage, artistName, artistDescription, artistSocial, artistWebsite, sculpture } = artist

	return (
		<div className={`info-list__item ${ index % 2 ? 'info-list__item--alt' : ''}`}>
			<div className="info-list__image-container">
				{ artistImage?.imageFile?.childImageSharp?.fluid &&
					<Img className="info-list__image info-list__image--artist" fluid={ artistImage.imageFile.childImageSharp.fluid } imgStyle={{ objectFit: "contain" }} />
				}
			</div>

			<div className="info-list__info">
				<h3 className="info-list__heading">{ artistName }</h3>
				<ReactMarkdown
					className="info-list__description"
					children={ artistDescription }
				/>
				<div className={`info-list__social-list ${ !artistSocial.length ? 'info-list__social-list--no-social' : '' }`}>
					{ artistWebsite &&
						<a href={ artistWebsite } className="info-list__link" target="_blank" rel="noreferrer">
							Visit Website
						</a>
					}
					{ !!artistSocial.length &&
						<div className={`info-list__social-icons ${ !artistWebsite ? 'info-list__social-icons--no-margin' : '' }`}>
							{ artistSocial.map( social => (
								<a href={ social.socialLink } className="info-list__icon-link" target="_blank" rel="noreferrer" key={ social.id }>
									{ social.social === "Instagram" && <IconInstagram className="info-list__icon" /> }
									{ social.social === "Facebook" && <IconFacebook className="info-list__icon" /> }
									{ social.social === "LinkedIn" && <IconLinkedin className="info-list__icon" /> }
									{ social.social === "Twitter" && <IconTwitter className="info-list__icon" /> }
								</a>
							) ) }
						</div>
					}
					{ sculpture &&
						<span className="info-list__alt-link-container">
							Sculpture Painted:
							<Link to={`${ trailYear ? `/${ trailYear }` : '' }/sculptures/${ sculpture.sculptureSlug }`} className="info-list__link">
								{ sculpture.sculptureName }
							</Link>
						</span>
					}
				</div>
			</div>
		</div>
	)
}
